import React,{useState,useContext} from 'react'
import NavIcon from '../images/Mobile/MobNavIcon.png'
import Back from '../images/Mobile/Back1.png'
import More from '../images/Mobile/more1.png'
import { useNavigate } from 'react-router-dom'
import { DBContext } from '../DBContext'

function NavBar({title,state,handleState}) { 

  const { logginedDB , user , getName , sideNavState , sideNavStateFunc , rightNavState , rightNavStateFunc } = useContext(DBContext);

  const navigate = useNavigate(null)
  const toBack = (section) => {
    if (section==='viewOrders') {
      handleState()
    } else if (section==='mobileKOT') {
      navigate('/tableview')
    }
  }

  const handleSideNavState = () => {
		sideNavStateFunc(sideNavState)
    rightNavStateFunc(true)
	}

  const handleRightNavState = () => {
    sideNavStateFunc(true)
		rightNavStateFunc(rightNavState)
	}

  return (
    <div className='w-full h-max flex bg-[#0008B4] text-[#fff] p-[.8rem] justify-center items-center font-nunito relative'>
        <div className='absolute left-0 flex w-max pl-3'>
            {/* <img className='w-[1rem]' src={state==='viewOrders' ? Back : state==='mobileKOT' ? Back : NavIcon} alt="?" 
            onClick={
              state==='tableview' ? () => toBack('tableview') : 
              state==='viewOrders' ? () => toBack('viewOrders') : 
              state==='mobileKOT' ? () => toBack('mobileKOT') : ''}/> */}
            {
              (state==='viewOrders' || state==='mobileKOT')  ? (
                <div className='w-max h-max flex flex-col justify-end items-end gap-[.3rem] cursor-pointer relative' onClick={
                  state==='viewOrders' ? () => toBack('viewOrders') : 
                  state==='mobileKOT' ? () => toBack('mobileKOT') : ''}>
                    <div className='w-[.95rem] h-[.15rem] bg-[#fff] rotate-[140deg] rounded-[.313rem]'></div>
                    <div className='w-[.95rem] h-[.15rem] bg-[#fff] rotate-[-140deg] rounded-[.313rem]'></div>
                </div>
              ) : (
                <div className="w-max h-max flex flex-col justify-end items-end gap-[.3rem] cursor-pointer relative" onClick={handleSideNavState}>
                    <div className={`w-[1.5rem] transition-transform duration-300 bg-[#fff] ${sideNavState ? 'absolute transform rotate-[135deg] h-[.2rem]' : 'h-[.175rem]'}`}></div>
                    <div className={`w-[2rem] h-[.175rem] bg-[#ffffff] transition-all duration-300 ${sideNavState ? 'hidden' : 'block'}`}></div>
                    <div className={`w-[1.5rem] transition-transform duration-300 bg-[#fff] ${sideNavState ? 'transform rotate-[-135deg] h-[.2rem] ' : 'h-[.175rem]'}`}></div>
                </div>
              )
            }
        </div>
        <span className='flex justify-center items-center font-[600] text-[1.25rem] w-full'>{title}</span>
        <div className='absolute right-0 flex w-max pr-3' onClick={handleRightNavState}>
            <img className='w-[.25rem]' src={state==='viewOrders' ? '' : More} alt="" />
        </div>
    </div>
  )
}

export default NavBar
